module.exports = __webpack_public_path__ + "img/appAsset-agents-avatar-12.ea10019e.jpg";